"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - Custom Select Component
 * 完全自定義的下拉選單，支援完整樣式控制
 * 支援 Portal 渲染，避免被父容器的 overflow 限制
 */
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const utils_1 = require("../../utils");
const class_variance_authority_1 = require("class-variance-authority");
const customSelectVariants = (0, class_variance_authority_1.cva)('h-10 flex items-center relative block w-full border border-solid rounded-md shadow-sm px-3 text-sm focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 bg-white dark:bg-slate-700 cursor-pointer', {
    variants: {
        variant: {
            default: 'border-gray-300 focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:border-brand-500 dark:border-gray-600 dark:text-white',
            error: 'border-red-500 focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:border-red-500 dark:border-red-600 dark:text-white'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
exports.CustomSelect = react_1.default.forwardRef(({ className, variant, id, name, value, onChange, options, placeholder, disabled, forceUp, searchable, searchPlaceholder, ...props }, ref) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [query, setQuery] = (0, react_1.useState)('');
    const keyword = query.trim().toLowerCase();
    const visibleOptions = searchable && keyword ? options.filter(opt => opt.label.toLowerCase().includes(keyword)) : options;
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(options.find(opt => opt.value === value) || null);
    const [dropdownPosition, setDropdownPosition] = (0, react_1.useState)({
        top: 0,
        left: 0,
        width: 0,
        openUpward: false
    });
    const selectRef = (0, react_1.useRef)(null);
    const buttonRef = (0, react_1.useRef)(null);
    const dropdownRef = (0, react_1.useRef)(null);
    // 🔧 修復 1: 組件卸載時強制關閉 dropdown
    (0, react_1.useEffect)(() => {
        return () => {
            setIsOpen(false);
        };
    }, []);
    // 🔧 修復 2: 監聽頁面 beforeunload 事件，確保重新整理時清理
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = () => {
            setIsOpen(false);
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);
    // 🔧 修復 3: 監聽頁面可見性變化，切換 tab 時關閉 dropdown
    (0, react_1.useEffect)(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                setIsOpen(false);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, []);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            // 檢查點擊是否在按鈕或下拉選單內
            if (selectRef.current && !selectRef.current.contains(event.target) &&
                dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    (0, react_1.useEffect)(() => {
        setSelectedOption(options.find(opt => opt.value === value) || null);
    }, [value, options]);
    // 關閉時清掉搜尋字
    (0, react_1.useEffect)(() => {
        if (!isOpen)
            setQuery('');
    }, [isOpen]);
    // 計算下拉選單位置（智能判斷向上或向下展開）
    (0, react_1.useEffect)(() => {
        if (isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const dropdownHeight = Math.min(options.length * 40, 240) + (searchable ? 48 : 0); // 估算下拉選單高度（max-h-60 = 240px＋搜尋框）
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            const openUpward = forceUp || (spaceBelow < dropdownHeight && spaceAbove > spaceBelow);
            setDropdownPosition({
                top: openUpward ? rect.top - dropdownHeight : rect.bottom,
                left: rect.left,
                width: rect.width,
                openUpward
            });
        }
    }, [isOpen, options.length]);
    const handleSelect = (option) => {
        if (option.disabled)
            return;
        setSelectedOption(option);
        setIsOpen(false);
        onChange?.(option.value);
    };
    const handleKeyDown = (event) => {
        if (disabled)
            return;
        switch (event.key) {
            case 'Enter':
            case ' ':
                event.preventDefault();
                setIsOpen(!isOpen);
                break;
            case 'Escape':
                setIsOpen(false);
                break;
            case 'ArrowDown':
                event.preventDefault();
                if (!isOpen) {
                    setIsOpen(true);
                }
                else {
                    // Navigate to next option
                    const currentIndex = selectedOption ? options.indexOf(selectedOption) : -1;
                    const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
                    const nextOption = options[nextIndex];
                    if (nextOption && !nextOption.disabled) {
                        handleSelect(nextOption);
                    }
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (!isOpen) {
                    setIsOpen(true);
                }
                else {
                    // Navigate to previous option
                    const currentIndex = selectedOption ? options.indexOf(selectedOption) : -1;
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
                    const prevOption = options[prevIndex];
                    if (prevOption && !prevOption.disabled) {
                        handleSelect(prevOption);
                    }
                }
                break;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "relative", ref: selectRef, children: [(0, jsx_runtime_1.jsx)("select", { id: id, name: name, value: value || '', onChange: () => { }, className: "sr-only", tabIndex: -1, children: options.map(option => ((0, jsx_runtime_1.jsx)("option", { value: option.value, children: option.label }, option.value))) }), (0, jsx_runtime_1.jsx)("div", { ref: (node) => {
                    buttonRef.current = node;
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                    else if (ref) {
                        ref.current = node;
                    }
                }, className: (0, utils_1.cn)(customSelectVariants({ variant }), className), onClick: () => !disabled && setIsOpen(!isOpen), onKeyDown: handleKeyDown, tabIndex: disabled ? -1 : 0, role: "combobox", "aria-expanded": isOpen, "aria-haspopup": "listbox", ...props, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex w-full items-center justify-between", children: [(0, jsx_runtime_1.jsx)("span", { className: (0, utils_1.cn)("block truncate", !selectedOption && "text-gray-500 dark:text-gray-300"), children: selectedOption ? selectedOption.label : placeholder || '' }), (0, jsx_runtime_1.jsx)("svg", { className: (0, utils_1.cn)("ml-2 h-4 w-4 transition-transform", isOpen && "transform rotate-180"), fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) })] }) }), isOpen && (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)("div", { ref: dropdownRef, className: "fixed z-[200] bg-white dark:bg-slate-700 border-2 border-slate-400 dark:border-slate-500 rounded-md shadow-2xl ring-1 ring-black ring-opacity-5", style: {
                    top: `${dropdownPosition.top}px`,
                    left: `${dropdownPosition.left}px`,
                    width: `${dropdownPosition.width}px`
                }, children: [searchable && ((0, jsx_runtime_1.jsx)("div", { className: "p-2 border-b border-gray-200 dark:border-gray-600", children: (0, jsx_runtime_1.jsx)("input", { type: "search", autoFocus: true, value: query, onChange: (e) => setQuery(e.target.value), onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const first = visibleOptions.find(opt => !opt.disabled);
                                    if (first)
                                        handleSelect(first);
                                }
                                else if (e.key === 'Escape') {
                                    setIsOpen(false);
                                }
                            }, placeholder: searchPlaceholder, "aria-label": searchPlaceholder, className: "w-full h-8 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-slate-800 px-2 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500" }) })), (0, jsx_runtime_1.jsxs)("ul", { role: "listbox", className: "py-1 max-h-60 overflow-auto", children: [visibleOptions.length === 0 && ((0, jsx_runtime_1.jsx)("li", { className: "px-3 py-2 text-sm text-gray-500 dark:text-gray-300", children: "\u2014" })), visibleOptions.map((option) => ((0, jsx_runtime_1.jsx)("li", { className: (0, utils_1.cn)("px-3 py-2 text-sm cursor-pointer border-b border-gray-200 dark:border-gray-600 last:border-b-0 text-gray-900 dark:text-white", option.disabled && "opacity-50 cursor-not-allowed", !option.disabled && "hover:bg-slate-100 dark:hover:bg-slate-600", selectedOption?.value === option.value && "bg-brand-50 dark:bg-brand-900/50 text-brand-600 dark:text-brand-400"), onClick: () => handleSelect(option), role: "option", "aria-selected": selectedOption?.value === option.value, children: option.label }, option.value)))] })] }), document.body)] }));
});
exports.CustomSelect.displayName = 'CustomSelect';
